import { view } from '@esui/core';
import { HSTack } from '@esui/core/layout/index.js';
import { css } from 'lit';
import { DemoPage, Section } from '../@demo/utils.js';
import { Fab } from './index.js';

export const [FabDemo] = view('fab-demo', {
  template() {
    return DemoPage(
      Section(
        '',
        HSTack(
          Fab('edit'),
          Fab('add').mini(),
          Fab('shopping_cart').extended().label('Add To Cart'),
          Fab('share').className('blackAndWhite')
        ).gridGap('3rem')
      )
    );
  },
  cssTemplate: css`
    .blackAndWhite {
      --mdc-theme-on-secondary: black;
      --mdc-theme-secondary: white;
    }
  `,
});
